import moment from 'moment';
import Pikaday from 'pikaday';


'use strict';

var NAME       = 'date-select';
var NAMESPACE  = 'hogo.' + NAME;
var SELECTOR   = '[data-' + NAME + ']';
var LOCALE     = {
    'en': {
        'OK': 'OK'
    }
};

var $body = $(document.body);


/**
 * Simple function to help ease translations.
 *
 * @param  {String}  lang
 * @param  {String}  key
 */
function lang (lang, key)
{
    if (typeof LOCALE[lang] !== 'undefined') {
        if (typeof LOCALE[lang][key] !== 'undefined') {
            return LOCALE[lang][key];
        }
    }

    return lang + '.' + key;
}

/**
 * Constructor.
 *
 * @param  {DOMElement|string}  element
 * @param  {object}             options
 */
var DateSelect = function (element, options)
{
    var self = this;

    this.$element = $(element);
    this.controls = {
        startRange: null,
        endRange: null
    };
    this.picker = null;

    this.data = this.$element.data(NAME);
    this.currentIndex = 0;
    this.locale = this.$element.data(NAME + '-locale') || 'en';

    this.$element.addClass(NAME);

    this.renderControls();

    // The start range should be the first one to be selected.
    this.controls.startRange.selecting = true;
}

DateSelect.VERSION = '0.1.0';

/**
 * Render a new control for each name passed.
 */
DateSelect.prototype.renderControls = function ()
{
    this.controls.startRange = this.renderControl(this.data[0]);
    this.$element.append(this.controls.startRange.$container);

    // Only render if a second endRange object was passed.
    if (typeof this.data[1] !== 'undefined') {
        this.controls.endRange = this.renderControl(this.data[1]);
        this.$element.append(this.controls.endRange.$container);
    }

}

/**
 * Render an individual control.
 */
DateSelect.prototype.renderControl = function (data)
{
    var name  = data.name || '';
    var value = data.value || '';
    var label = data.label || '';

    var control = {
        $input: this.renderControlInput(name, value),
        $label: this.renderControlLabel(label),
        $value: this.renderControlValue(value),
        $icon: this.renderControlIcon(),
        $container: this.renderControlContainer(),
        value: null,
        selecting: false
    };

    control.$container.append(
        control.$input,
        control.$label,
        control.$value,
        control.$icon
    );

    return control;
}

/**
 * <input type="text" readonly="readonly" name="{{ name }}" value="{{ value }}" />
 */
DateSelect.prototype.renderControlInput = function (name, value)
{
    return $('<input type="text" readonly="readonly" name="' + name + '" value="' + value + '" />');
}

/**
 * <div class="date-select-label">{{ label }}</div>
 */
DateSelect.prototype.renderControlLabel = function (label)
{
    return $('<div class="' + NAME + '-label">' + label + '</div>');
}

/**
 * <div class="date-select-value">{{ value }}</div>
 */
DateSelect.prototype.renderControlValue = function (value)
{
    var mmt = moment(value);
    return $('<div class="' + NAME + '-value">' + mmt.format('DD-MM-YYYY') + '</div>');
}

/**
 * <i class="date-select-icon material-icons">&#x916</i>
 */
DateSelect.prototype.renderControlIcon = function ()
{
    return $('<i class="' + NAME + '-icon material-icons">&#xE916</i>');
}

/**
 * <div class="date-select-control"></div>
 */
DateSelect.prototype.renderControlContainer = function (control)
{
    return $('<div class="' + NAME + '-control"></div>');
}

/**
 * Returns whether or not this is a date range select or not.
 *
 * @return  {boolean}
 */
DateSelect.prototype.isDateRange = function ()
{
    return typeof this.dateRange !== 'undefined';
}

/**
 * Returns the container to add the picker to.
 *
 * @return  {Element}
 */
DateSelect.prototype.getContainer = function ()
{
    return this.$container;
}

/**
 * Updates the interface based on the current properties.
 */
DateSelect.prototype.update = function ()
{
    for (var i in this.controls) {
        var mmt = moment(this.controls[i].value);
        this.controls[i].$input.val(mmt.isValid() ? mmt.format('YYYY-MM-DD') : '');
        this.controls[i].$value.text(mmt.isValid() ? mmt.format('DD-MM-YYYY') : '');
    }

}

/**
 * Sets the current date of the date select.
 *
 * @param  {String}  date
 */
DateSelect.prototype.setDate = function (date)
{
    this.controls.startRange.value = date;
}

/**
 * Sets the date for the start of the date range.
 *
 * @param  {Date}  date
 */
DateSelect.prototype.setStartRange = function (date) {
    this.controls.startRange.value = date;
    this.picker.setStartRange(date);
}

/**
 * Sets the date for the end of the date range.
 *
 * @param  {Date}  date
 */
DateSelect.prototype.setEndRange = function (date) {
    this.controls.endRange.value = date;
    this.picker.setEndRange(date);
}

/**
 * Triggered when a date is selected on the datepicker.
 *
 * @param  {String}  date
 * @param  {Object}  inst
 */
DateSelect.prototype.onSelect = function (date)
{

    // Date Range Selecting
    if (this.controls.endRange) {
        if (date <= this.controls.startRange.value || this.controls.startRange.selecting) {
            this.setStartRange(date);

            // Automatically set end range to next day.
            var endDate = new Date(date);
            endDate.setDate(endDate.getDate() + 1);
            this.setEndRange(endDate);

            this.controls.startRange.selecting = false;
            this.controls.endRange.selecting   = true;
        } else if (this.controls.endRange.selecting) {
            this.setEndRange(date);
            this.controls.startRange.selecting = true;
            this.controls.endRange.selecting   = false;
        }
    } else {
        this.setStartRange(date);
    }

    // Redraw!
    this.update();
    this.picker.draw();
};

/**
 * Create the third-party picker.
 */
DateSelect.prototype.createPicker = function ()
{

    if (this.picker) {
        return this.picker;
    }
    var startRange = this.controls.startRange.value || null;
    var endRange = this.controls.endRange.value || null;

    var minDate = moment().toDate();
    var maxDate = moment().add(1, 'years').toDate();

    return this.picker = new Pikaday({
        field: this.$element[0],
        container: this.$modalContent[0],
        bound: false,
        minDate: minDate,
        maxDate: maxDate,
        //disableWeekends: true,
        defaultDate: this.value,
        setDefaultDate: true,
        startRange: startRange,
        endRange: endRange,
        onDraw: function(inst) {
            $(inst.el).find('.pika-table').wrap('<div class="pika-table-container"></div>');
        },
        onSelect: $.proxy(this.onSelect, this)
    });
}

/**
 * Shows the datepicker.
 */
DateSelect.prototype.show = function ()
{
    this.renderModal();
    this.createPicker();
    this.$modal.fadeIn(250);
}

/**
 * <div class="date-select-modal-cover"></div>
 */
DateSelect.prototype.renderModalCover = function ()
{
    return this.$modalCover = $('<div class="' + NAME + '-modal-cover"></div>');
}

/**
 * <button class="button">OK</button>
 */
DateSelect.prototype.renderModalOk = function ()
{
    return this.$modalOk = $('<button class="btn">' + lang(this.locale, 'OK') + '</button>')
        .on('click', $.proxy(this.hide, this));
}

/**
 * <div class="date-select-modal-actions"></div>
 */
DateSelect.prototype.renderModalActions = function ()
{
    return this.$modalActions = $('<div class="' + NAME + '-modal-actions"></div>')
        .append(this.renderModalOk());
}

/**
 * <div class="date-select-modal-content"></div>
 */
DateSelect.prototype.renderModalContent = function ()
{
    return this.$modalContent = $('<div class="' + NAME + '-modal-content"></div>');
}

/**
 * <div class="date-select-modal-container"></div>
 */
DateSelect.prototype.renderModalContainer = function ()
{
    return this.$modalContainer = $('<div class="' + NAME + '-modal-container"></div>')
        .append(this.renderModalContent(), this.renderModalActions());
}

/**
 * <div class="date-select-modal"></div>
 */
DateSelect.prototype.renderModal = function ()
{
    if (this.$modal) {
        return this.$modal;
    }

    this.renderModalCover();
    this.renderModalActions();

    // Append to body
    this.$modal = $('<div class="' + NAME + '-modal"></div>')
        .append(this.renderModalCover(), this.renderModalContainer())
        .appendTo('body');

}

/**
 * Hides the datepicker.
 */
DateSelect.prototype.hide = function ()
{

    var self = this;

    if ( ! this.controls.endRange.value) {
        var date = new Date(this.controls.startRange.value);
        date.setDate(date.getDate() + 1);
        this.setEndRange(date);
        this.update();
    }

    if (this.$modal) {

        this.$modalOk.off('click');

        this.$modal.fadeOut(250, function () {
            if (self.picker) {
                self.picker.destroy();
                self.picker = null;
            }

            self.$modal.remove();
            self.$modal = null;
        });
    }
}


// DATE SELECT PLUGIN DEFINITION
// =============================

function Plugin (option)
{

    var args = [];
    for (var i = 1; i < arguments.length; i++) {
        args.push(arguments[i]);
    }

    return this.each(function () {
        var $this = $(this);
        var data  = $this.data(NAMESPACE);

        if ( ! data) $this.data(NAMESPACE, (data = new DateSelect(this)));
        if (typeof option === 'string') data[option].apply(data, args);
    });
}

$.fn.dateSelect             = Plugin;
$.fn.dateSelect.Constructor = DateSelect;


// APPLY TO STANDARD DATE SELECT ELEMENTS
// ======================================

$(SELECTOR).dateSelect();


// BIND EVENTS
// ===========

$(document)
    // Stop any propagation if clicking within the modal
    .on('click.' + NAMESPACE, '.' + NAME + '-modal', function (e) {
        e.stopImmediatePropagation();
    })
    // Close the modal if the cover is clicked on.
    .on('click.' + NAMESPACE, '.' + NAME + '-modal-cover', function (e) {
        var $input = $(SELECTOR);
        Plugin.call($input, 'hide');
    })
    // Show the modal when the element is clicked.
    .on('click.' + NAMESPACE, '.' + NAME, function (e) {
        Plugin.call($(this), 'show');
    });


// EXPORT MODULE
// =============

export default DateSelect;